import { InlineIcon } from "@iconify/react/dist/iconify.js";
import { toast } from "react-toastify";

type CopierProps = {
  content: string;
};

export function Copier({ content }: CopierProps) {
  return (
    <button
      type="button"
      onClick={() => {
        navigator.clipboard.writeText(content);
        toast.success("Copied to clipboard");
      }}
      className="ml-2 hover:opacity-80 cursor-pointer hover:bg-gray-200 rounded-md! p-1 hover:shadow-sm"
      title="Copy message"
    >
      <InlineIcon icon="mdi:content-copy" className="w-4 h-4" />
      <span className="sr-only">Copy to clipboard</span>
    </button>
  );
}
